import {Injectable} from '@angular/core';
import {DelegoAuthenticationValidation} from '@app/payment/services/delego-rapidpay/validation/delego-athentication-validations.model';
import {UntilDestroy} from '@ngneat/until-destroy';
import {DelegoRapidPayThreeDSecureInfoWithDelegoToken} from '../../../../model/delego-rapidpay/delego-rapidpay-authenticate';
import {
  DelegoRapidPayThreeDSecureStatus,
  DelegoRapidPayThreeDSecureStatusReason,
} from '../../../../model/delego-rapidpay/delego-rapidpay.enum';
import {DefaultDelegoAuthenticationValidationService} from './default-delego-authentication-validation.service';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class AmexDelegoAuthenticationValidationService implements DelegoAuthenticationValidation {
  constructor(private defaultDelegoAuthenticationValidationService: DefaultDelegoAuthenticationValidationService) {}

  isValid(authResponse: DelegoRapidPayThreeDSecureInfoWithDelegoToken): boolean {
    return this.customAmexValidation(authResponse);
  }

  /**
   * AMEX credit card authentication considered as valid for status "U"(UnableToComplete)
   * if eci is "07" AND statusReason is "01"(CARD_AUTHENTICATION_FAILED) or statusReason is "80"
   */
  private customAmexValidation(authResponse: DelegoRapidPayThreeDSecureInfoWithDelegoToken): boolean {
    return (
      this.defaultDelegoAuthenticationValidationService.isValid(authResponse) ||
      (authResponse?.status === DelegoRapidPayThreeDSecureStatus.UnableToComplete &&
        authResponse?.eci === '07' &&
        (authResponse?.statusReason === DelegoRapidPayThreeDSecureStatusReason.CARD_AUTHENTICATION_FAILED ||
          authResponse?.statusReason ===
            DelegoRapidPayThreeDSecureStatusReason.CARD_AUTHENTICATION_FAILED_AMEX_PLASTICLESS))
    );
  }
}
